// extracted by mini-css-extract-plugin
module.exports = {"form-wrapper":"clientEditView_form-wrapper__c1YgU"};